import { render, staticRenderFns } from "./FreshTelegram.vue?vue&type=template&id=64ed6a67&"
import script from "./FreshTelegram.vue?vue&type=script&lang=js&"
export * from "./FreshTelegram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports